const initialState = {
    container: [],
};

export const MAX_SIZE = 50;
export const actionSpreader = (type, payload) => ({ type, payload });
export const actionTypes = {
    FLUSH_CONTAINER: 'FLUSH_CONTAINER',
    ADD_TO_CONTAINER: 'ADD_TO_CONTAINER',
};
/*
 * Handles changes of state based on each action.type, called via dispatch
 * @param state {Object}: contains state variables defined in FormContext
 * @param action {Object}: contains action.type = action and action.name = fieldName
 * @returns {Array} the options to render
 */
export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FLUSH_CONTAINER:
            return {
                ...state,
                container: [],
            };
        case actionTypes.ADD_TO_CONTAINER:
            return {
                ...state,
                container: [...state.container, action.payload],
            };
        default:
            return state;
    }
}
